import { DateTime } from 'luxon'

const DAY_KEYS = ['MO', 'TU', 'WE', 'TH', 'FR', 'SA', 'SU']

export const nextWorkingDay = (data, locale, timezone?: string) => {
  const now = timezone ? DateTime.now().setZone(timezone) : DateTime.local()
  const currentDay = DAY_KEYS[now.weekday - 1]
  const currentTime = now.toFormat('HH:mm')

  const workingTime = data[currentDay]?.workingTime
  const isOpen = data[currentDay]?.open

  if (isOpen) {
    if (!isWithinWorkingTime(workingTime, currentTime)) {
      return findNextOpenTime(data, currentDay, currentTime, locale, now)
    }
  } else {
    return findNextOpenTime(data, currentDay, currentTime, locale, now)
  }
}

function isWithinWorkingTime(workingTime, currentTime) {
  for (const interval of workingTime) {
    if (currentTime >= interval.openingTime && currentTime <= interval.closingTime) {
      return true
    }
  }
  return false
}

function findNextOpenTime(data, currentDay, currentTime, locale, now: DateTime) {
  const days = ['MO', 'TU', 'WE', 'TH', 'FR', 'SA', 'SU']
  const dayIndex = days.indexOf(currentDay)

  for (let i = dayIndex; i < days.length + dayIndex; i++) {
    const day = days[i % days.length]
    const nextWorkingTime = data[day]?.workingTime
    const isOpen = data[day]?.open

    if (isOpen) {
      for (const interval of nextWorkingTime) {
        if (i === dayIndex && currentTime >= interval.openingTime) {
          continue
        }

        const targetDay = now
          .plus({ days: i - dayIndex })
          .toFormat('dd.MM.yyyy')

        const fullDayName = now
          .plus({ days: i - dayIndex })
          .toFormat('EEEE', {
            locale: locale,
          })

        return {
          day: fullDayName,
          date: targetDay,
          openingTime: interval.openingTime,
        }
      }
    }
  }

  return null
}
